// import * as React from 'react'
// import gql from 'graphql-tag'
// import { useQuery } from '@apollo/react-hooks'
// import { useAmp } from 'next/amp'

// import { ProductImageUrls } from '@thg-commerce/gravity-elements/Product/ProductImage/ProductImage'
// import { ProductBlock } from '@thg-commerce/gravity-patterns/ProductBlock'
// import { truncate } from '@thg-commerce/enterprise-core/src/utils/string'
//
// import { ProductOverviewSkeleton } from './ProductOverviewSkeleton'
// import { useProductPageSku } from '../../context/ProductPageContext/hooks'
//
// interface ProductOverviewResult {
//   title: string
//   url: string
//   images: ProductImageUrls[]
//   description: string
// }

// export const PRODUCT_BLOCK_RENDERER_QUERY = gql`
//   query ProductOverview($sku: SKU!) {
//     productOverview(sku: $sku, strict: false) @client {
//       title
//       url
//       images(limit: 1) {
//         largeProduct
//       }
//       description
//     }
//   }
// `

export const ProductOverviewRenderer = () => {
  // const sku = useProductPageSku()
  // const isAmp = useAmp()
  // const { data, loading } = useQuery<{
  //   productOverview: ProductOverviewResult
  // }>(PRODUCT_BLOCK_RENDERER_QUERY, {
  //   variables: { sku },
  // })

  // if (loading) {
  //   return <ProductOverviewSkeleton />
  // }

  // if (!loading && data?.productOverview) {
  //   const descriptionWordsLimit = 20
  //   return (
  //     <ProductBlock
  //       title={{ value: data.productOverview?.title }}
  //       url={data.productOverview?.url}
  //       image={{
  //         isAmp,
  //         urls: {
  //           largeProduct: data.productOverview?.images[0]?.largeProduct,
  //         },
  //         width: ['100%', '130px'],
  //         height: ['100%', '130px'],
  //         maxWidths: ['300px'],
  //         altText: data.productOverview?.title,
  //       }}
  //       directions={['column', 'row']}
  //       description={
  //         data.productOverview?.description &&
  //         truncate(data.productOverview.description, descriptionWordsLimit)
  //       }
  //     />
  //   )
  // }

  return null
}
